import { scrollAnimate } from 'utils/scroll';

export const nodeHeight = (node) => node.clientHeight;
export const windowHeight = () => (window || {}).innerHeight;

export const scrollPossibleArea = () => windowHeight() * 2;

const mainContainerNode = () => document.getElementsByTagName('BODY')[0];
export const scrollToTop = (callback) => scrollAnimate(mainContainerNode(), callback, 0, 150);
